let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d7cga")).then(() => parcelRequire('5E2TF'));